<template>
  <div id="app">
    <frame />
    <router-view />
  </div>
</template>

<script>
import frame from "@/components/Frame.vue";

import Vue from "vue";
import Buefy from "buefy";

Vue.use(Buefy);

import VueSwal from "vue-swal";

Vue.use(VueSwal);

export default {
  name: "App",
  components: {
    frame
  },
  metaInfo() {
    return {
      title: "איילת נוף עורכת דין ונוטריון",
      meta: [
        {
          name: "description",
          content: "איילת נוף עורכת דין"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

$primary: #8c67ef;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);

$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);

$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Update Buefy Variables - Navbar
$navbar-height: 11rem;
$navbar-background-color: #fff2cc;
$navbar-item-color: #4d3900;
$navbar-item-hover-color: #000000;
$navbar-item-hover-background-color: transparent;

// Update Buefy Variables - Footer
$footer-background-color: #fffffb;
$footer-padding: 0.9rem 1rem 1rem !default;

@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>

// Local css
<style scoped>
#app {
  background-color: #fffffb;
}
</style>

// Global css
<style>
.main-title {
  text-align: center;
  font-weight: bold;
  font-size: 381%;
  color: #003333;
  padding-bottom: 3.8vh;
}
</style>